import type { TLRecord } from "tldraw";
import { YKeyValue } from "y-utility/y-keyvalue";
import type { Doc } from "yjs";

const yRecordsCache = new WeakMap<Doc, YKeyValue<TLRecord>>();

export function getYRecords(document: Doc) {
	let records = yRecordsCache.get(document);
	if (!records) {
		records = new YKeyValue<TLRecord>(document.getArray("records"));
		yRecordsCache.set(document, records);
	}
	return records;
}
